// extracted by mini-css-extract-plugin
export default {"banned":"banned_banned__b9qTA","titleContainer":"banned_titleContainer__f7P8J","reasonContainer":"banned_reasonContainer__q2Uw+","arrow":"banned_arrow__QH9j6"};